import { render, staticRenderFns } from "./FiltroLeis.vue?vue&type=template&id=66e3df9e&scoped=true&"
import script from "./filtroLeis.ts?vue&type=script&lang=ts&"
export * from "./filtroLeis.ts?vue&type=script&lang=ts&"
import style0 from "./FiltroLeis.vue?vue&type=style&index=0&id=66e3df9e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66e3df9e",
  null
  
)

export default component.exports